<template>
  <div>
    <!-- START STEP 1-->
    <section class="pedido-steps" v-if="!form_success">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link :to="route">
                <img :src="require('@/assets/img/backspace.svg')" class="mb-5" alt="backspace">
              </router-link>
            </div>
            <div class="section-title">
              <h4>Creación de Cuota</h4>
              <router-link :to="route + 'cuota-listado'">
                <img class="d-none d-sm-block" :src="require('@/assets/img/backspace.svg')" alt="backspace">
              </router-link>
            </div>
            <p class="subtitulo">En esta sección puede crear una nueva cuota</p>
          </div>
        </div>
        <form method="GET" id="form-id">
          <div class="row">

            <div v-if="this.country === 'Argentina'" class="col-md-6">
              <div class="form-group">
                <label>Región
                </label>
                <VueMultiselect
                    v-model="selectedZone"
                    :options="zoneOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    label="displayText"
                    :loading="loadingZone"
                    :disabled="loading"
                    @select="handleSelectChange"
                    @remove="unselectZone"
                />
                <span class="required-span" v-if="this.errorsForm.zone">La región es obligatoria</span>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group" id="sku">
                <label>SKU
                  <Tooltip :parent="'sku'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <VueMultiselect
                    v-model="selectedSku"
                    :options="skuOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    label="displayText"
                    :loading="loadingSKU"
                    :disabled="(this.country === 'Argentina' && !this.selectedZone) || loading"
                />
                <span class="required-span" v-if="this.errorsForm.sku">El SKU es obligatorio</span>
              </div>
            </div>

            <div v-if="this.country === 'Mexico'" class="col-md-6" id="channels">
              <div class="form-group">
                <label>Channel
                  <Tooltip :parent="'channels'" :message="'Canal de Venta en Mccain.'">?</Tooltip>
                </label>
                <VueMultiselect
                    v-model="selectedZone"
                    :options="zoneOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    label="displayText"
                />
                <span class="required-span" v-if="this.errorsForm.zone">El channel es obligatorio</span>
              </div>
            </div>

            <div v-if="this.country === 'Calatin' || this.country === 'Argentina'" class="col-md-6"
                 id="client">
              <div class="form-group">
                <label>Cliente
                  <Tooltip :parent="'client'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <VueMultiselect
                    v-model="selectedClient"
                    :options="clientOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    label="displayText"
                    :loading="loadingClient"
                    :disabled="(this.country === 'Argentina' && !this.selectedZone) || loading"
                />
                <span class="required-span" v-if="this.errorsForm.client">El cliente es obligatorio</span>
              </div>
            </div>

            <div v-if="this.country === 'Calatin'" class="col-md-6">
              <div class="form-group">
                <label>Planta
                  <Tooltip :parent="'plant'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <VueMultiselect
                    v-model="selectedPlant"
                    :options="plantOptions"
                    :close-on-select="true"
                    :clear-on-select="false"
                    placeholder="Select one"
                    label="displayText"
                />
                <span class="required-span" v-if="this.errorsForm.plant">La planta es obligatoria</span>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group" id="start_date">
                <label>Fecha de Inicio
                  <Tooltip :parent="'start_date'" :message="'Fecha de inicio de la cuota.'">?</Tooltip>
                </label>
                <Datepicker
                    v-model="data.start_date"
                    name="start-date"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                    :disabled="loading"
                    @internal-model-change="handleZoneData"
                />
                <span class="required-span" v-if="this.errorsForm.start_date">{{ this.errorsForm.start_date[0] }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" id="final_date">
                <label>Fecha Final
                  <Tooltip :parent="'final_date'" :message="'Fecha final.'">?</Tooltip>
                </label>
                <Datepicker
                    v-model="data.final_date"
                    name="final-date"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                    :disabled="loading"
                    @internal-model-change="handleZoneData"
                />
                <span class="required-span" v-if="this.errorsForm.final_date">{{ this.errorsForm.final_date[0] }}</span>
              </div>
            </div>

            <div class="col-md-2" v-if="this.country === 'Argentina'">
              <div class="form-group" id="_quote_quantity">
                <label>Cuota Zona
                  <Tooltip :parent="'quantity'" :message="'Cantidad de cuota zona creada.'">?
                  </Tooltip>
                </label>
                <div v-if="loadingAvailable" class="loading-container">
                  <div class="spinner"></div>
                </div>
                <div v-else>
                  <input type="text" id="quote_quantity" name="quote_quantity" v-model="data.cuota" disabled>
                </div>
              </div>
            </div>

            <div class="col-md-2" v-if="this.country === 'Argentina'">
              <div class="form-group" id="_availability_quantity">
                <label>Disponible Zona
                  <Tooltip :parent="'quantity'" :message="'Cantidad de cuota zona disponible.'">?
                  </Tooltip>
                </label>
                <div v-if="loadingAvailable" class="loading-container">
                  <div class="spinner"></div>
                </div>
                <div v-else>
                  <input type="text" id="availability_quantity" name="availability_quantity"
                         v-model="data.disponible_zona" disabled>
                </div>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group" id="_quantity">
                <label>Cantidad
                  <Tooltip :parent="'quantity'" :message="'Cantidad de sku máximo permitidos para la compra.'">?
                  </Tooltip>
                </label>
                <input type="text" id="quantity" name="quantity" v-model="data.quantity">
                <span class="required-span" v-if="this.errorsForm.quantity">La cantidad es obligatoria.</span>
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12 next-btn d-none d-md-block">
            <a href="javascript:void(0)" @click="submitForm()" class="btn-green">Guardar</a>
            <a @click="cancelCuota()" href="javascript:void(0)" class="btn-white">Cancelar</a>
          </div>
          <!-- Botones para dispositivos pequeños -->
          <div class="col-12 next-btn d-block d-md-none mb-3">
            <a href="javascript:void(0)" @click="submitForm()" class="btn-green"
               style="margin-right: auto; margin-left: auto;">Guardar</a>
          </div>

          <div class="col-12 next-btn d-block d-md-none mb-3">
            <a @click="cancelCuota()" href="javascript:void(0)" class="btn-white"
               style="margin-right: auto; margin-left: auto;">Cancelar</a>
          </div>

          <div class="loading d-none"></div>
        </div>
        <div class="loading" v-if="loading"></div>
      </div>
    </section>

    <ItemCreated v-if="form_success"></ItemCreated>

  </div>
  <vue-basic-alert :duration="700" :closeIn="1000000" ref="alert"/>
</template>

<script>
import {route} from '@/enviroment';
import axios from 'axios';
import ItemCreated from '../../snippets/ItemCreated.vue';
import Tooltip from '../../snippets/Tooltip.vue';

export default {
  name: 'CuotaNueva',
  data: function () {
    return {
      route: route,
      country: '',
      data: this.defaultSelected(),
      errorsForm: this.defaultFieldsValues(),
      clients: [],
      selectedClient: null,
      clientOptions: [],
      skus: [],
      selectedSku: null,
      skuOptions: [],
      plants: [],
      selectedPlant: null,
      plantOptions: [],
      selectedVendedor: null,
      zones: [],
      selectedZone: null,
      loadingAvailable: false,
      loadingSKU: false,
      loadingClient: false,
      loadingZone: false,
      zoneOptions: [],
      filter: {},
      submit_disabled: false,
      form_success: false,
      selectedItem: null,
      cuota: "",
      disponible_zona: "",
      alertVisible: false,
      loading: false
    }
  },
  components: {
    ItemCreated,
    Tooltip
  },
  async created() {
    await this.getUser()
    if (this.country === 'Mexico') {
      this.getSkus();
      this.getZones();
    }
    if (this.country === 'Calatin') {
      this.getSkus();
      this.getClients();
      this.getPlants();
    }
    if (this.country === 'Argentina') {
      this.getZones();
    }
  },
  watch: {
    'selectedSku': function (element) {
      console.log(element)
      this.data.cuota = "";
      this.data.disponible_zona = '';
      this.filter.prev_start_date = null;
      this.filter.prev_final_date = null;
      this.handleZoneData();
    },
  },
  methods: {
    handleSelectChange() {
      if (this.country === 'Argentina') {
        this.selectedSku = null;
        this.selectedClient = null;
        this.data.start_date = null;
        this.data.final_date = null;
        this.data.cuota = "";
        this.data.disponible_zona = "";
        this.data.quantity = "";
        this.getSkus();
        this.getClients();
      }
    },
    unselectZone() {
      this.selectedSku = null;
      this.selectedClient = null;
      this.data.start_date = null;
      this.data.final_date = null;
      this.data.cuota = "";
      this.data.disponible_zona = "";
      this.data.quantity = "";
    },
    getFilterData() {
      const filterObject = JSON.parse(JSON.stringify(this.filter));
      if (this.selectedZone !== undefined && this.selectedZone !== null) {
        filterObject.selectedZone = this.selectedZone.value;
      } else filterObject.selectedZone = null;

      if (this.selectedSku !== undefined && this.selectedSku !== null) {
        const index = this.skus.findIndex((s) => s.code === this.selectedSku.value);
        if (index >= 0) {
          const sku = this.skus[index];
          filterObject.selectedEAN = sku.code;
          filterObject.selectedSku = sku.material;
        } else {
          filterObject.selectedEAN = null;
          filterObject.selectedSku = null;
        }
      } else {
        filterObject.selectedEAN = null;
        filterObject.selectedSku = null;
      }

      if (this.data.start_date !== undefined && this.data.start_date !== null && !isNaN(Date.parse(this.data.start_date))) {
        filterObject.start_date = (new Date(this.data.start_date)).toISOString().split('T')[0];
      } else if (isNaN(Date.parse(this.data.start_date))) filterObject.start_date = null;
      else filterObject.start_date = null;

      if (this.data.final_date !== undefined && this.data.final_date !== null && !isNaN(Date.parse(this.data.final_date))) {
        filterObject.final_date = (new Date(this.data.final_date)).toISOString().split('T')[0];
      } else if (isNaN(Date.parse(this.data.final_date))) filterObject.final_date = null;
      else filterObject.final_date = null;

      return this.filter = filterObject;
    },
    async handleZoneData() {
      if (this.country === 'Argentina') {
        const filter = this.getFilterData();
        if (!filter.selectedZone || !filter.selectedSku || !filter.start_date || !filter.final_date) {
          this.data.cuota = "";
          this.data.disponible_zona = '';
          this.filter.prev_start_date = null;
          this.filter.prev_final_date = null;
        }
        if (filter.selectedZone && filter.selectedSku && filter.start_date && filter.final_date &&
            (filter.start_date !== this.filter.prev_start_date || filter.final_date !== this.filter.prev_final_date)
        ) {
          try {
            this.data.cuota = "";
            this.data.disponible_zona = "";
            this.filter.prev_start_date = filter.start_date;
            this.filter.prev_final_date = filter.final_date;

            this.loadingAvailable = true;

            const filteredZonas = await this.filteredZonas(filter);
            if (filteredZonas.length > 0) {
              const selectedZona = filteredZonas[0];
              // Actualizar cuota y disponible_zona según el elemento seleccionado
              this.data.cuota = selectedZona.Cuota;
              this.data.disponible_zona = selectedZona.disponible_zona;
            }
            this.loadingAvailable = false;

          } catch (error) {
            console.error("Error al obtener las zonas filtradas:", error);
            // Manejar el error según tus necesidades
          }
        }
      }
    },
    async filteredZonas(filter) {
      try {
        let data = {
          'selectedZone': filter.selectedZone,
          'selectedEAN': filter.selectedEAN,
          'selectedSku': filter.selectedSku,
          'start_date': filter.start_date,
          'final_date': filter.final_date
        }
        const res = await axios.post(`/cuotificador/zones/quotation`, data);

        if (res.status === 200 && res.data.status === 'success') {
          const data = res.data.data;
          if (data.status.toString() === 'error') {
            throw new Error(data.message);
          }
          return data.zones.filter((zona) => {
            return (
                zona.ean === this.selectedSku.value &&
                zona.zona_nombre === this.selectedZone.value
            );
          });
        } else {
          throw new Error(res.data.message);
        }
      } catch (error) {
        console.error("Error al obtener datos de zonas:", error);
        throw error; // Relanzar el error para que pueda ser manejado por el código que llama a esta función
      } finally {
        this.loading = false;
      }
    },
    getUser() {
      const profile = sessionStorage.getItem('mccain_cuotas_user');
      if (profile) {
        const data = JSON.parse(profile);
        this.country = data.address.countryName;
        this.user = data.firstname + ' ' + data.lastname;
      }
    },
    getSkus() {
      this.loadingSKU = true;
      let data = this.country === 'Argentina' ? {"zone": this.selectedZone.value} : {};
      axios.post('cuotificador/data/skus', data)
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.skus = data.skus;
            this.skuOptions = this.skus.map((sku) => ({
              value: sku.code, // Valor a usar en el v-model
              displayText: this.customLabelSku(sku), // Texto visible en el VueMultiselect
            }));
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.skus = [];
            this.skuOptions = [];
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => this.loadingSKU = false);
    },
    getPlants() {
      axios.get('cuotificador/data/plants')
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.plants = data.plants;
            this.plantOptions = this.plants.map((plant) => ({
              value: plant.plant_id, // Valor a usar en el v-model
              displayText: `${plant.plant_id} - ${plant.plant_name}`, // Texto visible en el VueMultiselect
            }));
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.plants = [];
            this.plantOptions = [];
            this.showAlert('warning', 'Atención!', msg);
          });
    },
    getClients() {
      this.loadingClient = true;
      let data = this.country === 'Argentina' ? {"zone": this.selectedZone.value} : {};
      axios.post('cuotificador/data/clients', data)
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.clients = data.clients;
            this.clientOptions = this.clients.map((client) => {
              switch (this.country) {
                case 'Calatin':
                  return {
                    value: client.sold_to, // Valor a usar en el v-model
                    displayText: `${client.sold_to} - ${client.name_soldto}`, // Texto visible en el VueMultiselect
                  };
                default:
                  return {
                    value: client.cliente_codigo, // Valor a usar en el v-model
                    displayText: `${client.cliente_codigo} - ${client.cliente_nombre}`, // Texto visible en el VueMultiselect
                  };
              }
            });
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.clients = [];
            this.clientOptions = [];
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => this.loadingClient = false);
    },
    getZones() {
      this.loadingZone = true;
      axios.get('cuotificador/data/zones')
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.zones = data.zones;
            if (this.country === 'Mexico' || this.country === 'Calatin') {
              this.zoneOptions = this.zones.map((zone) => ({
                value: zone, // Valor a usar en el v-model
                displayText: `${zone}`, // Texto visible en el VueMultiselect
              }));
            }
            if (this.country === 'Argentina') {
              this.zoneOptions = this.zones.map(zone => ({
                value: zone.zona_nombre, // Valor a usar en el v-model
                displayText: zone.zona_nombre, // Texto visible en el VueMultiselect
              }));
            }
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.filterData.zones = [];
            this.zoneOptions = [];
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => this.loadingZone = false);
    },
    customLabelSku({code, name, material}) {
      return this.country === 'Mexico'
          ? `${material} - ${name} - ${code}`
          : `${code} - ${name} - ${material}`;
    },
    async cancelCuota() {
      const confirmed = await this.cancelConfirm();
      if (!confirmed) {
        return;
      }
      location.href = route + 'cuota-listado';
    },
    validateForm() {
      // Validate cuota and disponible_zona
      if (this.data.cuota === '' || this.data.disponible_zona === '') {
        return 'No hay cuota para la zona seleccionada.';
      }

      // Validate quantity
      if (this.data.quantity === '') {
        return 'La cantidad es requerida.';
      }

      // If all validations pass, return null
      return null;
    },
    prepareDataClone() {
      const dataCloned = JSON.parse(JSON.stringify(this.data));
      if (this.selectedPlant) dataCloned.plant_id = this.selectedPlant.value;
      if (this.selectedClient) dataCloned.sold_to = this.selectedClient.value;
      if (this.selectedSku) {
        const index = this.skus.findIndex((s) => s.code === this.selectedSku.value);
        if (index >= 0) {
          const sku = this.skus[index];
          dataCloned.sku = sku.code;
          dataCloned.sap = sku.material;
        }
      }
      if (this.selectedZone) dataCloned.zone = this.selectedZone.value;
      return dataCloned;
    },
    submitForm() {
      // Perform validations
      const validationError = this.validateForm();
      if (validationError) {
        this.alertVisible = true;
        this.showAlert('warning', 'Atención!', validationError);
        return;
      }

      this.loading = true;
      this.submit_disabled = true;

      const dataCloned = this.prepareDataClone();

      // eslint-disable-next-line
      axios.post('/cuotificador/cuota', Object.fromEntries(Object.entries(dataCloned).filter(([k, v]) => v)))
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.errorsForm = this.defaultFieldsValues();
            this.form_success = true;
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.alertVisible = true;
            this.showAlert('warning', 'Atención!', msg);
          })
          .finally(() => {
            this.submit_disabled = false;
            this.loading = false;
          });
    },
    defaultFieldsValues() {
      return {}
    },
    defaultSelected() {
      const values = this.defaultFieldsValues();
      return values;
    },
    async cancelConfirm() {
      return await this.$vbsModal.confirm({
        title: "Cancelar cuota",
        message: "Está seguro que desea cancelar la cuota?",
        leftBtnText: 'No',
        rightBtnText: 'Si',
        displayCloseBtn: false
      });
    },
    showAlert(type, title, message) {
      if (this.alertVisible) {
        this.$refs.alert.showAlert(
            type,
            message,
            title,
            {
              iconSize: 35,
              iconType: 'solid',
              position: 'top right',
            }
        );
        this.$refs.alert.$el.style.display = 'block';
        this.hideAlert();
      }
    },
    hideAlert() {
      setTimeout(() => {
        this.$refs.alert.$el.style.display = 'none';
        this.alertVisible = false
      }, 5000);  // 5 segundos y se borra
    },
  }
}
</script>

<style>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: auto;
  margin-top: 20px;
}

.spinner {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #ffc800; /* Blue */
  border-radius: 50%;
  width: auto;
  height: auto;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>